"use strict";
export function onAmountDrop(e) {
  var _a;
  if (e.stopPropagation) {
    e.stopPropagation();
  }
  e.preventDefault();
  const input = e.target;
  const setValue = (_a = Object.getOwnPropertyDescriptor(
    HTMLInputElement.prototype,
    "value"
  )) == null ? void 0 : _a.set;
  setValue == null ? void 0 : setValue.call(input, e.dataTransfer.getData("text/plain"));
  input.dispatchEvent(new Event("input", { bubbles: true }));
}
